/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/upcoming_race_entry_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./upcoming_race_entry_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient =
  function UpcomingRaceEntryServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient =
  function UpcomingRaceEntryServicePromiseClient(
    hostname,
    credentials,
    options
  ) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>}
 */
const methodDescriptor_UpcomingRaceEntryService_ListUpcomingRaceEntries =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ListUpcomingRaceEntries",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListUpcomingRaceEntriesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListUpcomingRaceEntriesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListUpcomingRaceEntriesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.listUpcomingRaceEntries =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ListUpcomingRaceEntries",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_ListUpcomingRaceEntries,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.listUpcomingRaceEntries =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ListUpcomingRaceEntries",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_ListUpcomingRaceEntries
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest,
 *   !proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 */
const methodDescriptor_UpcomingRaceEntryService_GetUpcomingRaceEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/GetUpcomingRaceEntry",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetUpcomingRaceEntryRequest,
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UpcomingRaceEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.getUpcomingRaceEntry =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/GetUpcomingRaceEntry",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_GetUpcomingRaceEntry,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.getUpcomingRaceEntry =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/GetUpcomingRaceEntry",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_GetUpcomingRaceEntry
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest,
 *   !proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 */
const methodDescriptor_UpcomingRaceEntryService_RequireUpcomingRaceEntryExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/RequireUpcomingRaceEntryExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.RequireUpcomingRaceEntryExamRequest,
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UpcomingRaceEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.requireUpcomingRaceEntryExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/RequireUpcomingRaceEntryExam",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_RequireUpcomingRaceEntryExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.requireUpcomingRaceEntryExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/RequireUpcomingRaceEntryExam",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_RequireUpcomingRaceEntryExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>}
 */
const methodDescriptor_UpcomingRaceEntryService_BulkAssignUpcomingRaceEntryExams =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/BulkAssignUpcomingRaceEntryExams",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.BulkAssignUpcomingRaceEntryExamsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListUpcomingRaceEntriesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListUpcomingRaceEntriesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.bulkAssignUpcomingRaceEntryExams =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/BulkAssignUpcomingRaceEntryExams",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_BulkAssignUpcomingRaceEntryExams,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.bulkAssignUpcomingRaceEntryExams =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/BulkAssignUpcomingRaceEntryExams",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_BulkAssignUpcomingRaceEntryExams
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest,
 *   !proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 */
const methodDescriptor_UpcomingRaceEntryService_UnassignUpcomingRaceEntryExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/UnassignUpcomingRaceEntryExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UnassignUpcomingRaceEntryExamRequest,
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UpcomingRaceEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.unassignUpcomingRaceEntryExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/UnassignUpcomingRaceEntryExam",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_UnassignUpcomingRaceEntryExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.unassignUpcomingRaceEntryExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/UnassignUpcomingRaceEntryExam",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_UnassignUpcomingRaceEntryExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest,
 *   !proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 */
const methodDescriptor_UpcomingRaceEntryService_QuickPassUpcomingRaceEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/QuickPassUpcomingRaceEntry",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.QuickPassUpcomingRaceEntryRequest,
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UpcomingRaceEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.quickPassUpcomingRaceEntry =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/QuickPassUpcomingRaceEntry",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_QuickPassUpcomingRaceEntry,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.quickPassUpcomingRaceEntry =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/QuickPassUpcomingRaceEntry",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_QuickPassUpcomingRaceEntry
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest,
 *   !proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 */
const methodDescriptor_UpcomingRaceEntryService_RevertQuickPassUpcomingRaceEntryExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/RevertQuickPassUpcomingRaceEntryExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.RevertQuickPassUpcomingRaceEntryExamRequest,
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UpcomingRaceEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.revertQuickPassUpcomingRaceEntryExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/RevertQuickPassUpcomingRaceEntryExam",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_RevertQuickPassUpcomingRaceEntryExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.revertQuickPassUpcomingRaceEntryExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/RevertQuickPassUpcomingRaceEntryExam",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_RevertQuickPassUpcomingRaceEntryExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>}
 */
const methodDescriptor_UpcomingRaceEntryService_BulkRequireAndAssignUpcomingRaceEntryRaceDayExams =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/BulkRequireAndAssignUpcomingRaceEntryRaceDayExams",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListUpcomingRaceEntriesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListUpcomingRaceEntriesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.bulkRequireAndAssignUpcomingRaceEntryRaceDayExams =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/BulkRequireAndAssignUpcomingRaceEntryRaceDayExams",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_BulkRequireAndAssignUpcomingRaceEntryRaceDayExams,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.bulkRequireAndAssignUpcomingRaceEntryRaceDayExams =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/BulkRequireAndAssignUpcomingRaceEntryRaceDayExams",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_BulkRequireAndAssignUpcomingRaceEntryRaceDayExams
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest,
 *   !proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 */
const methodDescriptor_UpcomingRaceEntryService_UnassignUpcomingRaceEntryRaceDayExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/UnassignUpcomingRaceEntryRaceDayExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UnassignUpcomingRaceEntryRaceDayExamRequest,
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UpcomingRaceEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.unassignUpcomingRaceEntryRaceDayExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/UnassignUpcomingRaceEntryRaceDayExam",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_UnassignUpcomingRaceEntryRaceDayExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.unassignUpcomingRaceEntryRaceDayExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/UnassignUpcomingRaceEntryRaceDayExam",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_UnassignUpcomingRaceEntryRaceDayExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest,
 *   !proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 */
const methodDescriptor_UpcomingRaceEntryService_SetUpcomingRaceEntryExamNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/SetUpcomingRaceEntryExamNote",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SetUpcomingRaceEntryExamNoteRequest,
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UpcomingRaceEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.setUpcomingRaceEntryExamNote =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/SetUpcomingRaceEntryExamNote",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_SetUpcomingRaceEntryExamNote,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.setUpcomingRaceEntryExamNote =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/SetUpcomingRaceEntryExamNote",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_SetUpcomingRaceEntryExamNote
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest,
 *   !proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 */
const methodDescriptor_UpcomingRaceEntryService_ResetUpcomingRaceEntryExamNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ResetUpcomingRaceEntryExamNote",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ResetUpcomingRaceEntryExamNoteRequest,
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UpcomingRaceEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.resetUpcomingRaceEntryExamNote =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ResetUpcomingRaceEntryExamNote",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_ResetUpcomingRaceEntryExamNote,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.resetUpcomingRaceEntryExamNote =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ResetUpcomingRaceEntryExamNote",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_ResetUpcomingRaceEntryExamNote
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest,
 *   !proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 */
const methodDescriptor_UpcomingRaceEntryService_SetUpcomingRaceEntryFlag =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/SetUpcomingRaceEntryFlag",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SetUpcomingRaceEntryFlagRequest,
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UpcomingRaceEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.setUpcomingRaceEntryFlag =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/SetUpcomingRaceEntryFlag",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_SetUpcomingRaceEntryFlag,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.setUpcomingRaceEntryFlag =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/SetUpcomingRaceEntryFlag",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_SetUpcomingRaceEntryFlag
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest,
 *   !proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 */
const methodDescriptor_UpcomingRaceEntryService_ResetUpcomingRaceEntryFlag =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ResetUpcomingRaceEntryFlag",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ResetUpcomingRaceEntryFlagRequest,
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UpcomingRaceEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UpcomingRaceEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServiceClient.prototype.resetUpcomingRaceEntryFlag =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ResetUpcomingRaceEntryFlag",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_ResetUpcomingRaceEntryFlag,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UpcomingRaceEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UpcomingRaceEntryServicePromiseClient.prototype.resetUpcomingRaceEntryFlag =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ResetUpcomingRaceEntryFlag",
      request,
      metadata || {},
      methodDescriptor_UpcomingRaceEntryService_ResetUpcomingRaceEntryFlag
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
